import React, { FC } from 'react';
import classNames from 'classnames';

export const AutocompleteEntityItem: FC<{
  selected: boolean;
  [s: string]: any;
}> = ({ selected, ...props }) => (
  <span
    {...props}
    className={classNames(
      'search-bar-dropdown__cell',
      'autocomplete-entity__item',
      props.className,
      {
        'autocomplete-entity__item--selected': selected,
      },
    )}
  />
);

export const AutocompleteEntityItemLabel: FC = props => (
  <span {...props} className="autocomplete-entity__label" />
);
